var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24.00 24.00",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ededed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "\\u9875\\u9762-1",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u56FE\\u6807",
    transform: "translate(-251.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(251.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    fillOpacity: 0.01,
    fillRule: "nonzero",
    height: 24,
    id: "\\u77E9\\u5F62",
    width: 24,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16 C20.20915,16 22,14.20915 22,12 C22,9.79085 20.20915,8 18,8",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16 L18,16 C20.20915,16 22,14.20915 22,12 C22,9.79085 20.20915,8 18,8",
    id: "\\u8DEF\\u5F84",
    stroke: "#ededed",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8 C3.79086,8 2,9.79085 2,12 C2,14.20915 3.79086,16 6,16",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8 C3.79086,8 2,9.79085 2,12 C2,14.20915 3.79086,16 6,16 L6,16",
    id: "\\u8DEF\\u5F84",
    stroke: "#ededed",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,16 L6,15.75 L6,14.5 L6,12 L6,8 C6,4.68629 8.6863,2 12,2 C15.3137,2 18,4.68629 18,8 L18,16 C18,19.3137 15.3137,22 12,22",
    id: "\\u8DEF\\u5F84",
    stroke: "#ededed",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.3587cdfe7adb4ed8a7d33f08c9a0cea5.svg";
export { ForwardRef as ReactComponent };